import { postRequest } from 'apis/ApiInstence';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const initialFormData = {
  mobile_number: '',
  email: '',
  address: '',
  instagram_link: '',
  facebook_link: '',
  youtube_link: '',
  whatsapp_number: '',
  map_link: '',
  status: 'active',
};

const AddSiteSetup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  // =========================
  // REGEX VALIDATIONS
  // =========================

  const mobileRegex = /^[6-9]\d{9}$/;

  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

  const urlRegex =
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;

  // =========================
  // HANDLE CHANGE
  // =========================

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // ONLY NUMBER FOR MOBILE
    if (name === 'mobile_number' || name === 'whatsapp_number') {
      updatedValue = value.replace(/\D/g, '').slice(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // REMOVE ERROR ON TYPE
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  // =========================
  // VALIDATION FUNCTION
  // =========================

  const validateForm = () => {
    const newErrors = {};

    // MOBILE NUMBER
    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = 'Mobile number is required';
    } else if (!mobileRegex.test(formData.mobile_number)) {
      newErrors.mobile_number =
        'Enter valid 10 digit mobile number';
    }

    // WHATSAPP NUMBER
    if (formData.whatsapp_number) {
      if (!mobileRegex.test(formData.whatsapp_number)) {
        newErrors.whatsapp_number =
          'Enter valid 10 digit WhatsApp number';
      }
    }

    // EMAIL
    if (formData.email) {
      if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Enter valid email address';
      }
    }

    // INSTAGRAM LINK
    if (formData.instagram_link) {
      if (!urlRegex.test(formData.instagram_link)) {
        newErrors.instagram_link =
          'Enter valid Instagram URL';
      }
    }

    // FACEBOOK LINK
    if (formData.facebook_link) {
      if (!urlRegex.test(formData.facebook_link)) {
        newErrors.facebook_link =
          'Enter valid Facebook URL';
      }
    }

    // YOUTUBE LINK
    if (formData.youtube_link) {
      if (!urlRegex.test(formData.youtube_link)) {
        newErrors.youtube_link =
          'Enter valid YouTube URL';
      }
    }

    // MAP LINK
    if (formData.map_link) {
      if (!urlRegex.test(formData.map_link)) {
        newErrors.map_link =
          'Enter valid Google Map URL';
      }
    }

    // ADDRESS
    if (!formData.address.trim()) {
      newErrors.address = 'Address is required';
    } else if (formData.address.trim().length < 10) {
      newErrors.address =
        'Address should be minimum 10 characters';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // =========================
  // SUBMIT
  // =========================

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      toast.error('Please fill all fields properly');
      return;
    }

    setLoading(true);

    try {
      await postRequest('sitesetup', formData);

      toast.success('Site setup added successfully');

      navigate('/sitesetup');
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to add site setup'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">
          Add Site Setup
        </h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-4">

          {/* MOBILE NUMBER */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="mobile_number"
              className="lables"
            >
              MOBILE NUMBER *
            </label>

            <input
              id="mobile_number"
              name="mobile_number"
              type="text"
              className={`form-control ${
                errors.mobile_number ? 'is-invalid' : ''
              }`}
              value={formData.mobile_number}
              onChange={handleChange}
              placeholder="Enter mobile number"
            />

            {errors.mobile_number && (
              <div className="invalid-feedback">
                {errors.mobile_number}
              </div>
            )}
          </div>

          {/* WHATSAPP NUMBER */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="whatsapp_number"
              className="lables"
            >
              WHATSAPP NUMBER
            </label>

            <input
              id="whatsapp_number"
              name="whatsapp_number"
              type="text"
              className={`form-control ${
                errors.whatsapp_number
                  ? 'is-invalid'
                  : ''
              }`}
              value={formData.whatsapp_number}
              onChange={handleChange}
              placeholder="Enter WhatsApp number"
            />

            {errors.whatsapp_number && (
              <div className="invalid-feedback">
                {errors.whatsapp_number}
              </div>
            )}
          </div>

          {/* EMAIL */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="email"
              className="lables"
            >
              EMAIL
            </label>

            <input
              id="email"
              name="email"
              type="text"
              className={`form-control ${
                errors.email ? 'is-invalid' : ''
              }`}
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
            />

            {errors.email && (
              <div className="invalid-feedback">
                {errors.email}
              </div>
            )}
          </div>

          {/* INSTAGRAM */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="instagram_link"
              className="lables"
            >
              INSTAGRAM LINK
            </label>

            <input
              id="instagram_link"
              name="instagram_link"
              type="text"
              className={`form-control ${
                errors.instagram_link
                  ? 'is-invalid'
                  : ''
              }`}
              value={formData.instagram_link}
              onChange={handleChange}
              placeholder="https://instagram.com/"
            />

            {errors.instagram_link && (
              <div className="invalid-feedback">
                {errors.instagram_link}
              </div>
            )}
          </div>

          {/* FACEBOOK */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="facebook_link"
              className="lables"
            >
              FACEBOOK LINK
            </label>

            <input
              id="facebook_link"
              name="facebook_link"
              type="text"
              className={`form-control ${
                errors.facebook_link
                  ? 'is-invalid'
                  : ''
              }`}
              value={formData.facebook_link}
              onChange={handleChange}
              placeholder="https://facebook.com/"
            />

            {errors.facebook_link && (
              <div className="invalid-feedback">
                {errors.facebook_link}
              </div>
            )}
          </div>

          {/* YOUTUBE */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="youtube_link"
              className="lables"
            >
              YOUTUBE LINK
            </label>

            <input
              id="youtube_link"
              name="youtube_link"
              type="text"
              className={`form-control ${
                errors.youtube_link
                  ? 'is-invalid'
                  : ''
              }`}
              value={formData.youtube_link}
              onChange={handleChange}
              placeholder="https://youtube.com/"
            />

            {errors.youtube_link && (
              <div className="invalid-feedback">
                {errors.youtube_link}
              </div>
            )}
          </div>

          {/* MAP LINK */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="map_link"
              className="lables"
            >
              MAP LINK
            </label>

            <input
              id="map_link"
              name="map_link"
              type="text"
              className={`form-control ${
                errors.map_link ? 'is-invalid' : ''
              }`}
              value={formData.map_link}
              onChange={handleChange}
              placeholder="https://maps.google.com/"
            />

            {errors.map_link && (
              <div className="invalid-feedback">
                {errors.map_link}
              </div>
            )}
          </div>

          {/* STATUS */}
          <div className="col-sm-6 mt-3">
            <label
              htmlFor="status"
              className="lables"
            >
              STATUS
            </label>

            <select
              id="status"
              name="status"
              className="form-control"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">
                Active
              </option>

              <option value="inactive">
                Inactive
              </option>
            </select>
          </div>

          {/* ADDRESS */}
          <div className="col-sm-12 mt-3">
            <label
              htmlFor="address"
              className="lables"
            >
              ADDRESS
            </label>

            <textarea
              id="address"
              name="address"
              className={`form-control ${
                errors.address ? 'is-invalid' : ''
              }`}
              rows="3"
              value={formData.address}
              onChange={handleChange}
              placeholder="Full site address..."
            />

            {errors.address && (
              <div className="invalid-feedback">
                {errors.address}
              </div>
            )}
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button
            type="submit"
            className="btn btn-lg addbtn"
            disabled={loading}
          >
            {loading
              ? 'Adding...'
              : 'Add Site Setup'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSiteSetup;